const deletedItems = {
  DELETEDITEMS: 'DELETEDITEMS',
  DELETEDITEM: 'DELETEDITEM'
}
export { deletedItems }
